export default "__VITE_ASSET__0533e30f__"